export default {
  get_all: { method: "get", url: "api/pedidos" },
  show: { method: "get", url: "api/pedidos/{id}" },
  show_payment: { method: "get", url: "api/pedidos/{id}/pagamento" },
  show_payments_history: {
    method: "get",
    url: "api/pedidos/{id}/pagamentos/historico",
  },
  cancel_order: { method: "post", url: "api/pedidos/{id}/cancelar" },
};
